











import { Vue, Component } from 'vue-property-decorator'

// components
import NavigationBar from '@/components/NavigationBar.vue'
import Header from '@/components/Header.vue'
import History from '@/components/History.vue'
import Services from '@/components/Services.vue'
import Contact from '@/components/Contact.vue'
import Footer from '@/components/Footer.vue'

@Component({
  components: {
    'nav-bar': NavigationBar,
    'home-header': Header,
    History,
    Services,
    Contact,
    'home-footer': Footer
  }
})
export default class Home extends Vue {

}
